import { Link } from "react-router-dom";
import FooterLogo from "../../assets/img/footer-logo.webp";
import { COMPANY_LINKS, INFO_LINKS, SOCIAL_LINKS } from "./Helper";

const Footer = () => {
  return (
    <div className="bg-black relative  text-white">
      <div className="container 2xl:max-w-[1200px] sm:py-20 py-16 px-5 mx-auto max-lg:mr-auto max-lg:flex max-lg:justify-start">
        <div className="flex flex-col lg:flex-row justify-between items-center sm:items-start lg:items-center max-lg:items-start gap-7 max-md:gap-4">
          <div className="w-full max-w-[473px] mb-5 lg:mb-0 max-sm:mb-0 max-lg:max-w-full">
            <Link className="lg:w-full" href="/">
              <img
                src={FooterLogo}
                alt="logo"
                className="pointer-events-none w-[201px] h-[66px]"
              />
            </Link>
            <p className="text-base max-sm:text-sm font-normal xl:mt-4 lg:max-w-[450px] text-[#D9D9D9] max-lg:mt-4 max-lg:max-w-full pb-4 pt-2">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </p>
            {/* SOCIAL_LINKS  */}
            <div className="flex items-center gap-3 mt-4">
              {SOCIAL_LINKS.map((obj, i) => (
                <a
                  href={obj.link}
                  key={i}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:scale-105 duration-300"
                >
                  {obj.img}
                </a>
              ))}
            </div>
          </div>
          <div className="flex flex-row  sm:gap-6 gap-3 sm:justify-between max-lg:max-w-full items-start w-full md:max-w-[325px] mt-5 sm:mt-0">
            {/* Quick Links  */}
            <div className="w-full sm:max-w-[150px] max-w-[150px] pb-3 sm:pb-0">
              <h4 className="text-lg sm:text-xl text-[#FCFEFF] font-normal uppercase sm:pb-5 pb-3">
                Quick Links
              </h4>
              {COMPANY_LINKS.map((link, index) => (
                <a
                  key={index}
                  className="block text-base max-sm:text-sm sm:py-1 py-0.5 hover:text-white text-[#D9D9D9] transition-all duration-200 ease-in-out"
                  href={link.href}
                >
                  {link.label}
                </a>
              ))}
            </div>
            {/* Terms Of Use links */}
            <div className="w-full sm:max-w-[150px] max-w-[150px] pb-3 sm:pb-0">
              <h4 className="text-lg sm:text-xl text-[#FCFEFF] font-normal uppercase sm:pb-5 pb-3">
                Terms Of Use
              </h4>
              {INFO_LINKS.map((link, index) => (
                <a
                  key={index}
                  className="block text-base max-sm:text-sm sm:py-1 py-0.5 hover:text-white text-[#D9D9D9]  transition-all duration-200 ease-in-out "
                  href={link.href}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-solid border-white/20">
        <p className="text-center text-base max-sm:text-sm py-4 text-white opacity-70">
          Powered by
          <strong className="font-semibold">
            {" "}
            &nbsp;
            <Link
              className="hover:text-yellow-400 duration-200"
              href="https://myservices.org.in/"
              target="_blank"
            >
              My Services
            </Link>
          </strong>
          — Let’s grow together 🌱 <br />© {new Date().getFullYear()}
          <strong>
            &nbsp;
            <span
              href="https://www.codemaster.org.in/"
              target="_blank"
              className=" duration-200 font-semibold"
            >
              TripNest
            </span>
          </strong>
          .
        </p>
      </div>
    </div>
  );
};

export default Footer;
